import { Component, OnInit } from '@angular/core';
import { URLSearchParams } from '@angular/http';
declare var _: any;

import { SessionService } from '../api/session.service';
import { AgencyService } from '../api/resources/agency.service';
import { RespondentService } from '../api/resources/respondents.service';

@Component({
  selector: 'app-saved-surveys',
  templateUrl: './saved-surveys.component.html',
  styleUrls: ['./saved-surveys.component.less'],
  providers: [
    SessionService,
    AgencyService,
    RespondentService
  ]
})
export class SavedSurveysComponent implements OnInit {
  agencyName: string;
  loading: boolean = true;
  savedSurveys: any = [];
  deleteModalOpen: boolean = false;
  deleteSurvey: any;
  modalState: string = 'default';

  constructor(private session: SessionService,
              private agency: AgencyService,
              private respondents: RespondentService) { }

  ngOnInit() {
    const agencyId = this.session.agency_id;
    const userId = this.session._id;
    const params = new URLSearchParams();

    params.set('limit', '1000');
    params.set('agency', agencyId);
    params.set('status', 'incomplete');
    params.set('user', userId);

    this.respondents.list({search: params})
      .subscribe(res => {
        this.savedSurveys = res;
        this.loading = false;
      });

    this.agency.detail(agencyId)
      .subscribe(res => {
        this.agencyName = res.name;
      }, err => console.log(err));
  }

  showDeleteModal(survey: any) {
    this.modalState = 'default';
    this.deleteSurvey = survey;
    this.deleteModalOpen = true;
  }

  delete(id: string) {
    this.modalState = 'loading';

    this.respondents.deleteRespondent(id)
      .subscribe(res => {
        this.savedSurveys = _.filter(this.savedSurveys, (s: any) => {
          return s._id !== id;
        });
        this.modalState = 'success';
        setTimeout(() => {
          this.deleteModalOpen = false;
        }, 1000);
      }, err => {
        this.modalState = 'error';
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/saved-surveys/saved-surveys.component.ts